import PageTemplate from "./PageTemplate";
import Experience from "../../../Experience";
import Home from "./Home";

export default class Jobs {
    constructor() {
        this.experience = new Experience()
        this.home = new Home()
        this.interaction = this.home.interaction
        this.resources = this.experience.resources

        if (this.resources.loaded === this.resources.toLoad) {
            this.setup()
        }
        else {
            this.resources.on("ready", () => {
                this.setup()
            })
        }
    }

    setup() {
        this.job1Image = this.resources.items.deloitte

        this.job1 = {
            name: "Deliotte",
            image: this.job1Image,
            listDescription: "2024 Aug - Present\n\nCurrently working with Saviynt",
            detailedDescription: "Developed and maintained Groovy scripts and JSON mappings to automate identity data integrations with downstream systems. Troubleshot complex provisioning, workflow, and integration issues. Wrote and optimized SQL queries for reporting, root-cause analysis, and data validation. Monitored scheduled jobs and platform health to ensure system reliability."
        }
        this.jobsList = [this.job1]

        this.template = new PageTemplate(
            "Experience",
            "#72FE15",
            "#6A2AEA",
            this.jobsList
        )
    }

    destroy() {
        this.template.destroy()
    }
}